export default "__VITE_ASSET__5XgTvUAH__"